import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconLinkOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.62501 8.22498L8.87501 7.44998C9.20835 7.35831 9.47918 7.18123 9.68751 6.91873C9.89585 6.65623 10 6.34998 10 5.99998C10 5.58331 9.85418 5.22915 9.56251 4.93748C9.27085 4.64581 8.91668 4.49998 8.50001 4.49998H6.50001V3.49998H8.50001C9.19168 3.49998 9.78126 3.74373 10.2688 4.23123C10.7563 4.71873 11 5.30831 11 5.99998C11 6.47498 10.8771 6.91248 10.6313 7.31248C10.3854 7.71248 10.05 8.01665 9.62501 8.22498ZM7.92501 6.49998L6.92501 5.49998H8.00001V6.49998H7.92501ZM9.90001 11.3L0.700012 2.09998L1.40001 1.39998L10.6 10.6L9.90001 11.3ZM5.50001 8.49998H3.50001C2.80835 8.49998 2.21876 8.25623 1.73126 7.76873C1.24376 7.28123 1.00001 6.69165 1.00001 5.99998C1.00001 5.42498 1.17501 4.91248 1.52501 4.46248C1.87501 4.01248 2.32501 3.71665 2.87501 3.57498L3.80001 4.49998H3.50001C3.08335 4.49998 2.72918 4.64581 2.43751 4.93748C2.14585 5.22915 2.00001 5.58331 2.00001 5.99998C2.00001 6.41665 2.14585 6.77081 2.43751 7.06248C2.72918 7.35415 3.08335 7.49998 3.50001 7.49998H5.50001V8.49998ZM4.00001 6.49998V5.49998H4.81251L5.80001 6.49998H4.00001Z",
		fill: "black",
		fillOpacity: .87
	})
});
export default SvgIconLinkOff;
